import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'

import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import Highlighter from 'react-highlight-words'

import BinModal from './components/BinModal'

import { GET_HERO_LIST } from '../../graphql/queries'
import { DELETE_HERO, CREATE_HERO, UPDATE_HERO } from '../../graphql/mutations'

const GetStatusColor = status => {
  let color = ''
  switch (status.toUpperCase()) {
    case 'REGISTERED':
      color = 'gold'
      break
    case 'PENDING':
      color = 'cyan'
      break
    case 'APPROVED':
      color = 'green'
      break
    case 'SUSPENDED':
      color = 'red'
      break
    case 'DISABLED':
      color = 'volcano'
      break
    default:
      break
  }
  return color
}

export class Bin extends Component {
  constructor() {
    super()

    this.state = {
      formOpen: false,
      formData: {},
      searchText: ''
    }

    this.openDialog = this.openDialog.bind(this)
    this.onCreate = this.onCreate.bind(this)
    this.onEdit = this.onEdit.bind(this)
    this.onDelete = this.onDelete.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm()
    this.setState({ searchText: selectedKeys[0] })
  }

  handleReset = clearFilters => {
    clearFilters()
    this.setState({ searchText: '' })
  }
  onCreate(params) {
    const { CreateHero } = this.props

    const self = this

    CreateHero({
      variables: params,
      refetchQueries: [
        {
          query: GET_HERO_LIST,
          variables: {
            heroType: ['CIRCULAR_BIN']
          }
        }
      ]
    })
      .then(result => {
        message.info(`Bin "${result.data.createHero.binId}" created successful`)
      })
      .then(() => {
        self.setState({
          formOpen: false
        })
      })
      .catch(error => {
        message.error(error.message)
      })
  }

  onEdit(id, params) {
    const { UpdateHero } = this.props

    const self = this

    UpdateHero({
      variables: { ...params, id },
      refetchQueries: [
        {
          query: GET_HERO_LIST,
          variables: {
            heroType: ['CIRCULAR_BIN']
          }
        }
      ]
    })
      .then(result => {
        message.info(`Bin "${result.data.updateHero.name}" update successful`)
      })
      .then(() => {
        self.setState({
          formOpen: false
        })
      })
      .catch(error => {
        message.error(error.message)
      })
  }

  onClose() {
    this.setState({
      formOpen: false,
      formData: {}
    })
  }

  onDelete(id) {
    const { DeleteHero, data } = this.props

    DeleteHero({
      variables: {
        id
      }
    })
      .then(result => {
        message.info(`Bin delete successful`)
        data.refetch()
      })
      .catch(error => {
        message.error(error.message)
      })
  }

  async openDialog(id) {
    // Set data id
    this.setState({
      formOpen: true,
      formData: {
        id
      }
    })
  }

  render() {
    const { data } = this.props
    const { formOpen, formData } = this.state
    const columns = [
      {
        title: 'Bin ID',
        dataIndex: 'binId',
        key: 'binId',
        ...this.getColumnSearchProps('binId')
      },
      {
        title: 'MAC Address',
        dataIndex: 'macAddress',
        key: 'macAddress',
        ...this.getColumnSearchProps('macAddress')
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        filters:
          data.statusOptions &&
          data.statusOptions.options.map(status => ({
            text: status.name,
            value: status.name
          })),
        onFilter: (value, record) => record.status === value,
        render: status => {
          let color = GetStatusColor(status)
          return (
            <span>
              <Tag color={color} key={status}>
                {status}
              </Tag>
            </span>
          )
        }
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => (
          <span>
            <Button
              type="primary"
              size="small"
              shape="circle"
              icon="edit"
              onClick={() => {
                this.openDialog(record.id)
              }}
            />
            <Divider type="vertical" />
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => this.onDelete(record.id)}
            >
              <Button type="danger" size="small" shape="circle" icon="delete" />
            </Popconfirm>
          </span>
        )
      }
    ]

    return (
      <Card
        title="Bin"
        extra={
          <div>
            <Button
              size="small"
              icon="plus"
              onClick={() => this.setState({ formOpen: true })}
            >
              Create Bin
            </Button>
            <Button size="small" icon="reload" onClick={() => data.refetch()}>
              Reload
            </Button>
          </div>
        }
      >
        <Table
          rowKey={record => record.id}
          dataSource={data.heroes}
          columns={columns}
        />
        <BinModal
          visible={formOpen}
          onClose={this.onClose}
          onCreate={this.onCreate}
          onEdit={this.onEdit}
          data={formData}
          options={data.statusOptions}
        />
      </Card>
    )
  }
}

Bin.propTypes = {
  data: PropTypes.object.isRequired,
  DeleteHero: PropTypes.func.isRequired,
  CreateHero: PropTypes.func.isRequired,
  UpdateHero: PropTypes.func.isRequired
}

export default compose(
  graphql(GET_HERO_LIST, {
    options: {
      variables: {
        heroType: ['CIRCULAR_BIN']
      }
    }
  }),
  graphql(DELETE_HERO, { name: 'DeleteHero' }),
  graphql(CREATE_HERO, { name: 'CreateHero' }),
  graphql(UPDATE_HERO, { name: 'UpdateHero' })
)(Bin)



// WEBPACK FOOTER //
// ./src/pages/Bin/index.js